var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtensils(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002 15.0001V67.5001C22.5002 75.7501 29.2502 82.5001 37.5002 82.5001H67.5002C71.4785 82.5001 75.2938 80.9198 78.1068 78.1067C80.9199 75.2937 82.5002 71.4784 82.5002 67.5001V15.0001M52.5002 15.0001V165M157.5 112.5V15.0001C147.555 15.0001 138.016 18.951 130.984 25.9836C123.951 33.0162 120 42.5545 120 52.5001V97.5001C120 105.75 126.75 112.5 135 112.5H157.5ZM157.5 112.5V165",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtensils);
export default __webpack_public_path__ + "static/media/utensils.505595a3392ec913792c05e35e343351.svg";
export { ForwardRef as ReactComponent };